export default "__VITE_ASSET__CHOcGn14__"